import React from 'react';
import { generateZipFromCloud } from '../../../../utils/generateZipFiles';
import { setScheduleId } from '../../../../redux/myCourse/myCourse.actions';
import { connect } from 'react-redux';
import UploadAssignment from '../submitFile/submitFile';

const TaskRows = ({
	isReUploadable,
	submitted_date,
	schedule_id,
	task_name,
	task_file,
	task_assigned,
	reviewed_file,
	files,
	setScheduleId,
}) => {
	const rowClick = (e) => {
		setScheduleId(parseInt(e.target.getAttribute('data-submit-id'), 10));
		document.getElementById(`divSubmitFile_${schedule_id}`).style.display =
			'block';
		window.scrollTo(0, document.body.scrollHeight);
		e.target.style.display = 'none';
	};

	const getSubmitLink = (text, scheduleId) => {
		return (
			<button
				className="btn btn-primary step-btn"
				data-submit-id={scheduleId}
				onClick={rowClick}
			>
				{text}
			</button>
		);
	};

	return (
		<tr key={schedule_id}>
			<td>
				{task_name}
				<br />
				<a
					target="_blank"
					className="pointer"
					href={`https://docs.google.com/viewer?url=${task_file}`}
				>
					{'[Download Assignment]'}
				</a>
			</td>
			<td>{task_assigned}</td>
			<td>
				{' '}
				{!!submitted_date ? submitted_date : 'Not Submitted'}
				<br />
			</td>
			<td>
				{!!submitted_date ? (
					<div>
						{isReUploadable
							? getSubmitLink('Reupload', schedule_id)
							: 'Task completed'}
					</div>
				) : (
					getSubmitLink('Submit Now', schedule_id)
				)}
				{(!submitted_date || isReUploadable) && (
					<UploadAssignment id={schedule_id} />
				)}
			</td>
		</tr>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		setScheduleId: (id) => dispatch(setScheduleId(id)),
	};
};

export default connect(null, mapDispatchToProps)(TaskRows);
